import * as yup from 'yup';
import ValidationUtil from "../Utils/ValidationUtil";

class CampaignMetaValidation {

    static async validate(form) {
        try {

            let objectValidade = {
                goal_type: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                goal_title: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                period: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                reward_type: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                goal_value: yup
                    .number(ValidationUtil.MSG_FIELD_NUMBER)
                    .max(999999999, ValidationUtil.MSG_FIELD_MAX_NUMBER)
                    .typeError(ValidationUtil.MSG_FIELD_NUMBER)
                    .positive(ValidationUtil.MSG_FIELD_POSITIVE)
                    .integer(ValidationUtil.MSG_INTERGER)
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                reward_points: yup
                    .number(ValidationUtil.MSG_FIELD_NUMBER)
                    .max(999999999, ValidationUtil.MSG_FIELD_MAX_NUMBER)
                    .typeError(ValidationUtil.MSG_FIELD_NUMBER)
                    .positive(ValidationUtil.MSG_FIELD_POSITIVE)
                    .integer(ValidationUtil.MSG_INTERGER)
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                company_uuid: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),

                //Award

                title: yup
                    .string()
                    .max(255, ValidationUtil.MSG_FIELD_MAX)
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                description: yup
                    .string()
                    .max(255, ValidationUtil.MSG_FIELD_MAX)
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                rules: yup
                    .string()
                    .max(255, ValidationUtil.MSG_FIELD_MAX)
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                amount: yup
                    .number(ValidationUtil.MSG_FIELD_NUMBER)
                    .max(999999999, ValidationUtil.MSG_FIELD_MAX_NUMBER)
                    .typeError(ValidationUtil.MSG_FIELD_NUMBER)
                    .positive(ValidationUtil.MSG_FIELD_POSITIVE)
                    .integer(ValidationUtil.MSG_INTERGER)
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),


            };

            if (form.reward_type === 'award') {
                delete objectValidade.reward_points;
            }

            if (form.reward_type === 'points') {
                delete objectValidade.title;
                delete objectValidade.rules;
                delete objectValidade.image;
                delete objectValidade.description;
                delete objectValidade.amount;
            }


            if (Array.isArray(form.images) && form.image === undefined) {
                delete objectValidade.image;
            }

            if (form.withoutValidDate === true) {
                delete objectValidade.start_at;
                delete objectValidade.end_at;
            }


            let validate = yup.object().shape(objectValidade);

            validate.validateSync(form, {abortEarly: false})

            return true;

        } catch (e) {
            let erros = [];
            e.inner.forEach(function (value, index) {
                erros[value.path] = value.message;
            });

            return erros;
        }
    }

}

export default CampaignMetaValidation;